import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgIf } from '@angular/common';

@Component({
    selector: 'formly-field-input',
    template: `
   <div class="mb-3">
	   <label>{{field.templateOptions.label}}<sup style="color:red;">*</sup></label>
	   <input name="endDate" type='text' class= 'form-control' placeholder="dd.mm.yyyy" [formlyAttributes]="field" [owlDateTime]="ledt" [owlDateTimeTrigger]="ledt" [class.error]="showError"/>
	   <owl-date-time  [pickerType]="'calendar'" #ledt></owl-date-time>
	   <formly-validation-message *ngIf="showError"
	    [field]="field"></formly-validation-message>
	</div>
 `,
    imports: [FormsModule, OwlDateTimeModule, OwlNativeDateTimeModule, ReactiveFormsModule, FormlyModule, NgIf]
})
export class DatePickerComponent extends FieldType {}
